<!--Side bar for eSOC upload-->
<p-sidebar
  (onHide)="eSOCUploadPopupClose()"
  [(visible)]="eSOCUploadDisplay"
  [showCloseIcon]="false"
  class="sidebar-sm eSockUpdate-confirmation-dialog"
  position="right"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <h2 class="gc-form-heading" pTooltip="IO Doc allows agencies to send important patient documents electronically via email or text. This includes Patient Handbooks, Patient Information Reports (PIR), and other patient-facing documents without needing to print or mail physical copies." tooltipPosition="bottom">
          Upload IO Document
        </h2>
      </div>
      <div>
        <span (click)="eSOCUploadPopupClose()" class="cursor-pointer"
          ><em class="pi pi-times"></em
        ></span>
      </div>
    </div>
    <br />
    <br />
  </ng-template>
  <form #eSockForm="ngForm">
    <div class="popup-wrapper">
      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Patient</h3>
        </div>
        <div class="flex align-items-center gap-3">
          <div *ngIf="hidePatientName; else elseBlock" class="py-3 pl-4">
            <p class="gc-agency-handle">{{ patientId }}</p>
          </div>
          <ng-template #elseBlock>
            <div class="py-3 pl-4">
              <p *ngIf="patientName" class="gc-agency-name">
                {{ patientName }}
              </p>
              <p class="gc-agency-handle">{{ MRN ? "MRN: " + MRN : "" }}</p>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Preferred Method</h3>
        </div>
        <div class="sidebar-form">
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center justify-content-between">
                <label>DOB<span class="red">*</span></label>
              </div>
              <span class="p-input-icon-left">
                <span class="gc-input-icon">
                  <img alt="calendar.svg" src="assets/images/calendar.svg" />
                </span>
                <p-calendar
                  #dob="ngModel"
                  (ngModelChange)="isDobValid()"
                  [(ngModel)]="eSockSubmissionForm.dob"
                  [class.dob-error]="
                    (dob.invalid && dob.touched) || showDobInvalidError
                  "
                  [required]="true"
                  class="w-full disable-calendar"
                  dateFormat="{{ dobDateFormat }}"
                  dateMask="99/99/9999"
                  name="dob"
                  placeholder="mm/dd/yyyy"
                ></p-calendar>
                <!--              <input id="dob" type="text" [(ngModel)]="eSockSubmissionForm.dob" required email pInputText name="dob" placeholder="mm/dd/yyyy" class="p-inputtext"/>-->
              </span>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center justify-content-between">
                <label
                  >Email<span *ngIf="isEmailMandatory()" class="red"
                    >*</span
                  ></label
                >
                <div class="flex align-items-center gap-2">
                  <p-checkbox
                    (onChange)="changeCheckboxValue()"
                    [(ngModel)]="eSockSubmissionForm.email.preferred"
                    [binary]="true"
                    inputId="email"
                    name="emailPrefferd"
                  ></p-checkbox>
                  <label>Send via Email</label>
                </div>
              </div>
              <span class="p-input-icon-left flex-grow-1">
                <span class="gc-input-icon"
                  ><img
                    alt="email-icon.svg"
                    src="../../assets/images/email-icon.svg"
                /></span>
                <input
                  [(ngModel)]="emailList[0].email"
                  [required]="isEmailMandatory()"
                  class="p-inputtext"
                  email
                  id="email-0"
                  name="email-0"
                  pInputText
                  placeholder="Email"
                  type="email"
                />
              </span>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <label>Additional Emails</label>
              <div *ngFor="let emailItem of emailList; let i = index">
                <span *ngIf="i > 0" class="p-input-icon-left flex-grow-1 mt-2">
                  <span class="gc-input-icon"
                    ><img
                      alt="email-icon.svg"
                      src="../../assets/images/email-icon.svg"
                  /></span>
                  <input
                    [(ngModel)]="emailItem.email"
                    class="p-inputtext"
                    email
                    [id]="'email-' + i"
                    [name]="'email-' + i"
                    pInputText
                    placeholder="Email"
                    type="email"
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center justify-content-between">
                <label
                  >Phone<span
                    *ngIf="eSockSubmissionForm.phoneNumber.preferred"
                    class="red"
                    >*</span
                  ></label
                >
                <div class="flex align-items-center gap-2">
                  <p-checkbox
                    (onChange)="changeCheckboxValue()"
                    [(ngModel)]="eSockSubmissionForm.phoneNumber.preferred"
                    [binary]="true"
                    inputId="phone"
                    name="phonePreffered"
                  ></p-checkbox>
                  <label>Send via Phone</label>
                </div>
              </div>
              <div class="flex gc-dialCode flex-grow-1">
                <p-dropdown
                  [(ngModel)]="phoneList[0].countryCode"
                  [options]="countries"
                  name="countryCode-0"
                  optionLabel="dial_code"
                  optionValue="dial_code"
                >
                  <ng-template let-country pTemplate="selectedItem">
                    <span
                      class="fi fi-{{ country?.code.toLowerCase() }} countryflag"
                    ></span>
                    <span class="country-code"> {{ country?.dial_code }}</span>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <span
                      class="fi fi-{{ country?.code.toLowerCase() }} countryflag"
                    ></span>
                    <span class="country-code"> {{ country?.dial_code }}</span>
                  </ng-template>
                </p-dropdown>
                <p-inputMask
                  (ngModelChange)="isPhoneNumberValid($event, 0)"
                  [(ngModel)]="phoneList[0].number"
                  [ngModelOptions]="{ standalone: true }"
                  aria-required="true"
                  class="w-full"
                  mask="999-999-9999"
                  name="phoneNumber-0"
                  placeholder="(XXX) XXX-XXXX"
                ></p-inputMask>
              </div>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <label>Additional Phones</label>
              <div *ngFor="let phoneItem of phoneList; let i = index">
                <div *ngIf="i > 0" class="flex gc-dialCode flex-grow-1 mt-2">
                  <p-dropdown
                    [(ngModel)]="phoneItem.countryCode"
                    [options]="countries"
                    [name]="'countryCode-' + i"
                    optionLabel="dial_code"
                    optionValue="dial_code"
                  >
                    <ng-template let-country pTemplate="selectedItem">
                      <span
                        class="fi fi-{{ country?.code.toLowerCase() }} countryflag"
                      ></span>
                      <span class="country-code"> {{ country?.dial_code }}</span>
                    </ng-template>
                    <ng-template let-country pTemplate="item">
                      <span
                        class="fi fi-{{ country?.code.toLowerCase() }} countryflag"
                      ></span>
                      <span class="country-code"> {{ country?.dial_code }}</span>
                    </ng-template>
                  </p-dropdown>
                  <p-inputMask
                    (ngModelChange)="isPhoneNumberValid($event, i)"
                    [(ngModel)]="phoneItem.number"
                    [ngModelOptions]="{ standalone: true }"
                    aria-required="true"
                    class="w-full"
                    mask="999-999-9999"
                    [name]="'phoneNumber-' + i"
                    placeholder="(XXX) XXX-XXXX"
                  ></p-inputMask>
                </div>
              </div>
            </div>
          </div>
          <!--        <div class="grid p-fluid">-->
          <!--          <div class="col-12">-->
          <!--            <div class="flex align-items-center justify-content-between">-->
          <!--              <label>DOB<span class="red">*</span></label>-->
          <!--              </div>-->
          <!--            <span class="p-input-icon-left">-->
          <!--              <span class="gc-input-icon">-->
          <!--                <img src="assets/images/calendar.svg">-->
          <!--              </span>-->

          <!--              <p-calendar [(ngModel)]="eSockSubmissionForm.dob" [required]="true" class="w-full" dateFormat="{{dobDateFormat}}" name="dob" placeholder="mm/dd/yyyy"></p-calendar>-->
          <!--&lt;!&ndash;              <input id="dob" type="text" [(ngModel)]="eSockSubmissionForm.dob" required email pInputText name="dob" placeholder="mm/dd/yyyy" class="p-inputtext"/>&ndash;&gt;-->
          <!--            </span>-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center gap-2">
                <p-checkbox
                  [(ngModel)]="eSockSubmissionForm.isChecked"
                  [binary]="true"
                  name="myCheckbox"
                  value="someValue"
                ></p-checkbox>
                <label>Yes! I agree to receive email or SMS</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-progressBar
        *ngIf="progressBar"
        [value]="value"
        class="esco-progressBar"
      ></p-progressBar>
      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Upload file</h3>
          <p-dropdown
            [(ngModel)]="eSOCUploadType"
            [autoDisplayFirst]="false"
            [options]="fileTypes"
            class="w-165"
            name="fileType"
          ></p-dropdown>
        </div>
        <div class="sidebar-form">
          <div class="grid p-fluid">
            <div *ngIf="showeSockDragAndDrop" class="dropzone" fileDragDrop>
              <div class="text-wrapper">
                <div class="dropFile-wra">
                  <input
                    (change)="handleFileUpload($event)"
                    [(ngModel)]="eSockSubmissionForm.eSockFile"
                    accept="application/pdf"
                    id="file"
                    name="file"
                    type="file"
                  />
                  <div
                    class="flex flex-column align-items-center justify-content-center gap-4"
                  >
                    <img
                      alt="File upload"
                      src="../../assets/images/fileupload.svg"
                    />
                    <label class="textLink" for="file"
                      >Drag and drop file here or <u>Choose file</u></label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="showUpdateAndDeleteEsock" class="fileupload-info">
              <div class="flex align-items-center gap-3 w-8">
                <img alt="" src="../../assets/images/Document.svg" />
                <label class="fileupload-text">{{ eSockFileName }}</label>
              </div>
              <div class="flex align-items-center gap-3">
                <button
                  (click)="deleteEdocFileConfirmation()"
                  class="btn-cancel p-button button-sm"
                  type="button"
                >
                  Delete
                </button>
                <button
                  (click)="updateEsockFile()"
                  *ngIf="hideReplaceEdockButton"
                  class="p-button button-sm"
                  type="button"
                >
                  Replace file
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="eSockFiles?.length || uploadedFile"
        class="gc-form-section eSockFiles"
      >
        <div class="gc-form-section-heading">
          <h3>History</h3>
        </div>
        <div class="px-4 py-3">
          <table
            [cellPadding]="0"
            [cellSpacing]="0"
            class="w-full"
            role="table"
          >
            <tr>
              <th class="col-3">File Name</th>
              <th class="col-2">File Type</th>
              <th class="col-2">Uploaded</th>
              <th class="col-2">Sent</th>
              <th class="col-2">Status</th>
            </tr>
            <tr *ngIf="uploadedFile">
              <td>{{ uploadedFile?.fileOriginalName }}</td>
              <td>{{ newFileUploadType[eSOCUploadType] }}</td>
              <td>{{ uploadedFile?.createdAt | customDate }}</td>
            </tr>
            <tr *ngFor="let file of slicedItems">
              <td>{{ file?.fileOriginalName || file?.fileName }}</td>
              <td>{{ fileTypeHistory[file?.fileType] }}</td>
              <td>{{ file?.createdAt | customDate }}</td>
              <td>{{ file?.activityDate | customDate }}</td>
              <td>{{ file?.status ? file?.status : fileNotOpened }}</td>
            </tr>
          </table>
          <div *ngIf="eSockFiles.length > 3" class="align-expand-text">
            <span (click)="expandCollapseHistory()">{{
              this.showNumberOfRows == 6 ? "See Less" : "See More"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="p-sidebar-footer button-container px-4">
      <button (click)="eSOCUploadPopupClose()" class="btn-cancel" pButton>
        Close
      </button>
      <button
        (click)="addeSocToSubmission(true)"
        [disabled]="
          !eSockForm.form.valid ||
          !isValidPhoneNumber ||
          !isFileUploadComplete ||
          showDobInvalidError
        "
        class="btn-cancel"
        pButton
      >
        Save
      </button>
      <button
        (click)="addeSocToSubmission(true, true)"
        [disabled]="
          !eSockForm.form.valid ||
          !isValidPhoneNumber ||
          !isFileUploadComplete ||
          !(
            (eSockSubmissionForm?.phoneNumber?.preferred &&
              phoneList.length > 0 && phoneList[0]?.number &&
              eSockSubmissionForm?.isChecked) ||
            (eSockSubmissionForm?.email?.preferred &&
              emailList.length > 0 && emailList[0]?.email &&
              eSockSubmissionForm?.isChecked)
          ) ||
          !eSockSubmissionForm.eSockFile ||
          showDobInvalidError
        "
        class=""
        pButton
      >
        Save & Send
      </button>
    </div>
  </ng-template>
</p-sidebar>
